/* Floow global components — shared across all Floow sections. See AGENTS/skill: Rule 5 (Modal). */
(function () {
  function floowEnsureModal() {
    if (document.querySelector('.floow-modal-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'floow-modal-overlay';
    overlay.innerHTML =
      '<div class="floow-modal-dialog" role="dialog" aria-modal="true">' +
      '<button type="button" class="floow-modal-close" aria-label="Schliessen">&times;</button>' +
      '<div class="floow-modal-content-container"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) window.floowCloseModal();
    });
    overlay.querySelector('.floow-modal-close').addEventListener('click', window.floowCloseModal);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') window.floowCloseModal();
    });
  }

  window.floowOpenModal = function (content) {
    floowEnsureModal();
    var overlay = document.querySelector('.floow-modal-overlay');
    var container = overlay.querySelector('.floow-modal-content-container');
    var closeBtn = overlay.querySelector('.floow-modal-close');

    container.innerHTML = '';
    container.appendChild(closeBtn);

    if (typeof content === 'string') {
      container.insertAdjacentHTML('beforeend', content);
    } else if (content instanceof Element) {
      container.appendChild(content.cloneNode(true));
    } else {
      return;
    }

    container.querySelectorAll('.floow-modal-hidden-content').forEach(function (el) {
      el.style.display = 'block';
    });

    overlay.classList.add('is-open');
    document.body.classList.add('floow-modal-open');

    container.querySelectorAll('video').forEach(function (video) {
      video.play().catch(function () {});
    });
  };

  window.floowCloseModal = function () {
    var overlay = document.querySelector('.floow-modal-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('floow-modal-open');
    overlay.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  };
})();

/* Floow delivery logic — shared by all Floow sections with a delivery date.
   Config comes from theme settings ("Floow Lieferlogik") via data attributes:
   data-cutoff-hour, data-cutoff-minute, data-transit-days, data-holidays. */
(function () {
  var WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var WEEKDAYS_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  // Current wall-clock time in Zurich, as a UTC-based Date (so getUTC* = Zurich local values)
  function zurichNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second));
  }

  function isoDate(d) {
    return d.toISOString().slice(0, 10);
  }

  function isWorkday(d, holidays) {
    var day = d.getUTCDay();
    return day !== 0 && day !== 6 && holidays.indexOf(isoDate(d)) === -1;
  }

  function nextWorkday(d, holidays) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkday(n, holidays));
    return n;
  }

  window.floowDelivery = {
    // Returns { delivery, shipsToday, msToCutoff, shipLabel } for an element carrying the config data attributes
    compute: function (el) {
      var cutoffH = parseInt(el.dataset.cutoffHour, 10);
      var cutoffM = parseInt(el.dataset.cutoffMinute, 10);
      var transit = parseInt(el.dataset.transitDays, 10);
      var holidays = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);

      var now = zurichNow();
      var cutoff = new Date(now.getTime());
      cutoff.setUTCHours(cutoffH, cutoffM, 0, 0);

      var shipsToday = isWorkday(now, holidays) && now < cutoff;
      var shipDay = shipsToday ? now : nextWorkday(now, holidays);

      var delivery = shipDay;
      for (var i = 0; i < transit; i++) delivery = nextWorkday(delivery, holidays);

      var tomorrow = new Date(now.getTime());
      tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);

      return {
        delivery: delivery,
        shipsToday: shipsToday,
        msToCutoff: cutoff - now,
        shipLabel: isoDate(shipDay) === isoDate(tomorrow) ? 'morgen' : 'am ' + WEEKDAYS_LONG[shipDay.getUTCDay()]
      };
    },

    formatDate: function (d) {
      var dd = String(d.getUTCDate()).padStart(2, '0');
      var mm = String(d.getUTCMonth() + 1).padStart(2, '0');
      return WEEKDAYS[d.getUTCDay()] + ', ' + dd + '.' + mm + '.';
    },

    formatCountdown: function (ms) {
      var totalMin = Math.max(1, Math.ceil(ms / 60000));
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      if (h === 0) return m + ' Min.';
      return m === 0 ? h + ' Std.' : h + ' Std. ' + m + ' Min.';
    }
  };
})();
